const topbar = {
    docs: '문서',
    help: '도움말',
};
export default Object.freeze(topbar);
